/**
 * 弹窗关窗时统一触发 optional handlers + onComplete。
 * handlers / onComplete 均可省略。
 */
export async function finishOnboardingModal<
  TAction extends string,
  TResult extends { action: TAction },
>(
  result: TResult,
  options?: {
    handlers?: Partial<Record<TAction, () => void | Promise<void>>>;
    onComplete?: (result: TResult) => void;
  },
): Promise<void> {
  const handler = options?.handlers?.[result.action];
  if (handler) {
    await handler();
  }
  options?.onComplete?.(result);
}
